<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sl1xZk/tc-custom/9780253057686.jpg?1721453852153" alt="This image is the cover for the book Politics, Money, and Persuasion, Studies in Continental Thought"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Politics, Money, and Persuasion, Studies in Continental Thought
      </h1>
      <p class="bookDescription body article font2">
        <p>In <i>Politics, Money, and Persuasion</i>, distinguished philosopher John Russon offers a new framework for interpreting Plato's <i>The Republic</i>. For Russon, Plato's work is about the distinctive nature of what it is to be a human being and, correspondingly, what is distinctive about the nature of human society. Russon focuses on the realities of our everyday experience to come to profoundly insightful assessments of our human realities: the nature of the city, the nature of knowledge, and the nature of human psychology. </p><p>Russon's argument concentrates on the ambivalence of logos, which includes reflections on politics and philosophy and their place in human life, how humans have shaped the environment, our interactions with money, the economy, and the pursuit of the good in social and political systems. </p><p><i>Politics, Money, and Persuasion</i> offers a deeply personal but also practical kind of philosophical reading of Plato's classic text. It emphasizes the tight connection between the life of city and the life of the soul, demonstrating both the crucial role that human cognitive excellence and psychological health play in political and social life.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Russon
      </h2>
      
      <p class="authorDescription body article"><P>John Russon is Professor of Philosophy at the University of Guelph and Director of the Toronto Summer Seminar in Philosophy. He is author of <I>Sites of Exposure: A Philosophy Essay on Art, Politics, and the Nature of Experience</I> and <I>Infinite Phenomenology: The Lessons of Hegel's Science of Experience</I>.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4804c229